import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "absolute right-0 z-20 flex h-[calc(100vh_-_72px)] w-80 max-w-full flex-col overflow-y-auto bg-white shadow-md shadow-black" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-center font-bold" }, " NOTIFICATIONS ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "my-2" }, null, -1)
const _hoisted_6 = { class: "block pb-0" }
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = { class: "pt-1 text-red-600" }
const _hoisted_9 = {
  key: 1,
  class: "m-auto"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" There are no notifications to display ")

import {
  InformationCircleIcon,
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import axios from 'axios';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {
  ref,
  onBeforeMount,
} from 'vue';
import {
  handleAxiosError,
} from '@/helpers';
import {
  useStore,
} from '@/store';
import {
  IPushNotificationHistory,
} from '@/type';


export default /*#__PURE__*/_defineComponent({
  __name: 'PushNotificationHistorySidebar',
  setup(__props) {


dayjs.extend(relativeTime);

const appStore = useStore.app;

const pushNotificationHistory = ref<IPushNotificationHistory[]>([]);

function formatTime(time = new Date().toISOString()): string {
  return dayjs(time).fromNow();
}

onBeforeMount(async () => {
  try {
    const response = await axios.get<{
      pushNotificationHistory: IPushNotificationHistory[]
    }>('/stock-choices/push-notification-history');

    pushNotificationHistory.value = response.data.pushNotificationHistory;
  } catch (e) {
    handleAxiosError(e);
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(appStore).sidebars.pushNotificationHistory.show)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          tabindex: "-1",
          class: "fixed inset-x-0 bottom-0 top-18 z-[19] h-full w-full cursor-default bg-black opacity-70",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).sidebars.pushNotificationHistory.show = false))
        }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          class: "absolute top-4 right-4 h-6 w-6 rounded-full text-[#ff0000] hover:bg-[#ff0000] hover:text-center hover:text-gray-100 hover:shadow-sm hover:shadow-gray-500 active:shadow-inner",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(appStore).sidebars.pushNotificationHistory.show = false))
        }, [
          _createVNode(_unref(XMarkIcon))
        ])
      ]),
      _hoisted_5,
      (pushNotificationHistory.value.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(pushNotificationHistory.value, (history) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${history.stockChoiceId}${history.notificationId}`,
              class: "px-4 py-2 text-sm hover:bg-gray-200"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(history.tradingCode), 1),
                _createTextVNode(" " + _toDisplayString(history.text), 1)
              ]),
              _createElementVNode("div", _hoisted_8, _toDisplayString(formatTime(history.createdAt)), 1)
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_unref(InformationCircleIcon), { class: "mx-auto h-8 w-8" }),
            _hoisted_10,
            _hoisted_11
          ]))
    ], 512), [
      [_vShow, _unref(appStore).sidebars.pushNotificationHistory.show]
    ])
  ]))
}
}

})